var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVulners = function SvgVulners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 40,
    fill: "none",
    viewBox: "0 0 36 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulners_svg__a)",
    fillRule: "evenodd",
    d: "M16.49.355 1.666 8.987a2.61 2.61 0 0 0-1.296 2.254v17.518c0 .928.494 1.786 1.296 2.254l14.823 8.632a2.61 2.61 0 0 0 2.637-.004l14.698-8.627a2.61 2.61 0 0 0 1.288-2.249v-17.53c0-.925-.49-1.78-1.288-2.25L19.127.36A2.61 2.61 0 0 0 16.49.355m-.026 7.618-8.128 4.733A2.61 2.61 0 0 0 7.04 14.96v9.642c0 .927.494 1.786 1.296 2.253l8.128 4.733a2.61 2.61 0 0 0 2.637-.004l8.055-4.728a2.61 2.61 0 0 0 1.288-2.249v-9.653c0-.925-.49-1.78-1.288-2.25L19.1 7.978a2.61 2.61 0 0 0-2.637-.004",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2D",
    fillRule: "evenodd",
    d: "M28.086 25.924c.23-.393.357-.846.357-1.317V13.785l6.405-3.694a2.6 2.6 0 0 0-1.024-1.105L19.126.359A2.61 2.61 0 0 0 16.49.355L1.666 8.987a2.6 2.6 0 0 0-1.03 1.105l6.403 3.693z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2D",
    fillRule: "evenodd",
    d: "M17.741 0a2.6 2.6 0 0 0-1.252.354L1.666 8.987a2.6 2.6 0 0 0-1.03 1.105l6.403 3.693V24.6c0 .473.129.927.36 1.321l10.342-5.965z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulners_svg__a",
    x1: 32.031,
    x2: -39.653,
    y1: 1.104,
    y2: 24.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgVulners;